import { METHOD } from './method'

export const API_PRODUCT = {
    COMPARISON: {
        api: '/v1/dashboard-admin/analytic/product/comparison',
        method: METHOD.POST,
    },
    GRAPH: {
        api: '/v1/dashboard-admin/analytic/product/graph',
        method: METHOD.POST,
    },
    LIST: {
        api: '/v1/dashboard-admin/analytic/product/list',
        method: METHOD.POST,
    },
    BRAND_LIST: {
        api: '/v1/dashboard-admin/analytic/product/brands',
        method: METHOD.GET,
    },
    EXPORT: {
        api: '/v1/dashboard-admin/analytic/product/export',
        method: METHOD.POST,
    },
}
